// Centralized WhatsApp helpers for Colega Link.
//
// Priority order for "joining" the community:
//   1. REACT_APP_WHATSAPP_GROUP_INVITE (chat.whatsapp.com/XXX) — preferred when set
//   2. Direct 1:1 chat to REACT_APP_WHATSAPP_CONTACT — fallback while the group
//      invite link is being created or rotated
//
// Use cases:
//   - joinGroupOrContactLink(): for "Unirme al grupo" CTAs (auto-detects group vs 1:1)
//   - directChatLink(message): for "Hablar con soporte / reservar Pionero" (always 1:1)
//   - hasGroupInvite(): boolean to render different copy when group link is configured
//
const GROUP_INVITE = (process.env.REACT_APP_WHATSAPP_GROUP_INVITE || "").trim();
const CONTACT_NUMBER = (process.env.REACT_APP_WHATSAPP_CONTACT || "56941199600").trim();

export const hasGroupInvite = () => Boolean(GROUP_INVITE);
export const getGroupInviteUrl = () => GROUP_INVITE;
export const getContactNumber = () => CONTACT_NUMBER;

/**
 * Returns the best URL to "join" the community.
 * If group invite is set → direct group join link.
 * Otherwise → 1:1 chat with the configured number, asking for the group invite.
 */
export function joinGroupOrContactLink(fallbackMessage) {
  if (GROUP_INVITE) return GROUP_INVITE;
  const msg = fallbackMessage || "Hola 👋 Quiero unirme al grupo de Colega Link. Por favor envíame el link de invitación al grupo de WhatsApp. ¡Gracias!";
  return `https://wa.me/${CONTACT_NUMBER}?text=${encodeURIComponent(msg)}`;
}

/** 1:1 chat with the contact number with a custom pre-filled message. */
export function directChatLink(message) {
  const text = message || "Hola 👋 Vengo de Colega Link.";
  return `https://wa.me/${CONTACT_NUMBER}?text=${encodeURIComponent(text)}`;
}
